"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\t", ";\n"], ["\n\tposition: relative;\n\t", ";\n"])), function (props) { return props.theme.textField.container; });
var Input = styled_components_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.textField.control; });
var Label = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.textField.label; });
var ErrorIcon = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.textField.errorIcon; });
var ErrorMessage = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.textField.errorMessage; });
var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField(props) {
        var _this = _super.call(this, props) || this;
        _this.getDecimalSeparator = function () {
            if (_this.props.formatter) {
                //Deduce any decimal separator
                var tester = _this.props.formatter.format(1.2);
                return tester.slice(tester.indexOf("1") + 1, tester.indexOf("2"));
            }
            throw new Error("Need a formatter to deduce any separator");
        };
        _this.cleanValue = function (value) {
            if (_this.props.formatter) {
                //Deduce any decimal separator
                var decimalSeparator = _this.getDecimalSeparator();
                //Remove any non-numeric characters and convert the decimal separator to a period
                var newValue = "";
                for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                    var char = value_1[_i];
                    if (char === decimalSeparator) {
                        newValue += ".";
                        decimalSeparator = undefined;
                    }
                    if (!Number.isNaN(Number.parseInt(char))) {
                        newValue += char;
                    }
                }
                value = newValue;
            }
            return value;
        };
        _this.onChange = function (ev) {
            var rawvalue = ev.target.value;
            var value = _this.cleanValue(rawvalue);
            if (_this.props.formatter) {
                if (value === "") {
                    if (_this.props.onChange) {
                        _this.props.onChange(ev.target.value);
                    }
                    return;
                }
                //If the only change was the removal of the decimal separator, truncate the number to an integer
                if (rawvalue === _this.state.rawvalue.replace(_this.getDecimalSeparator(), "")) {
                    value = value.slice(0, _this.state.value.indexOf("."));
                }
                var fixedValue = _this.props.formatter.format(Number.parseFloat(value));
                if (fixedValue !== rawvalue) {
                    var prevSelectionStart = ev.target.selectionStart || 0;
                    var beforeCursor = ev.target.value.slice(0, prevSelectionStart);
                    rawvalue = fixedValue;
                    ev.target.value = fixedValue;
                    for (var index = 0; index < fixedValue.length; ++index) {
                        if (beforeCursor.length === 0) {
                            ev.target.selectionStart = index;
                            ev.target.selectionEnd = index;
                            break;
                        }
                        if (beforeCursor[0] === fixedValue[index]) {
                            beforeCursor = beforeCursor.slice(1);
                        }
                        else if (Number.isNaN(Number.parseInt(beforeCursor[0]))) {
                            beforeCursor = beforeCursor.slice(1);
                        }
                    }
                    if (beforeCursor.length > 0) {
                        ev.target.selectionStart = prevSelectionStart;
                        ev.target.selectionEnd = prevSelectionStart;
                    }
                }
            }
            _this.setState({ value: value, rawvalue: rawvalue });
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        _this.onSubmit = function (ev) {
            var rawvalue = ev.target.value;
            var value = _this.cleanValue(rawvalue) || ev.target.value;
            if (_this.props.onSubmit) {
                _this.setState({ value: value, rawvalue: rawvalue });
                _this.props.onSubmit(value);
            }
        };
        _this.onKeyPress = function (ev) {
            if (_this.props.onSubmit && ev.charCode === 13) {
                var value = _this.cleanValue(ev.target.value) || ev.target.value;
                _this.props.onSubmit(value);
            }
            else if (_this.props.formatter) {
                var allowedCharacters = _this.props.formatter.format(1234567890.123456789);
                if (!allowedCharacters.includes(String.fromCharCode(ev.charCode))) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    return false;
                }
            }
            return undefined;
        };
        _this.onFocus = function () {
            _this.setState({ focused: true });
        };
        _this.onBlur = function (ev) {
            _this.setState({ focused: false });
            _this.onSubmit(ev);
        };
        _this.state = {
            value: _this.props.defaultValue,
            rawvalue: ((_this.props.defaultValue && _this.props.formatter) ? _this.props.formatter.format(Number.parseFloat(_this.props.defaultValue)) : _this.props.defaultValue) || "",
            focused: false
        };
        if (_this.props.format !== "text") {
        }
        return _this;
    }
    TextField.prototype.render = function () {
        return (react_1.default.createElement(Container, { className: this.props.className },
            react_1.default.createElement(Input, { inputMode: this.props.type, placeholder: !this.state.focused ? this.props.label : undefined, defaultValue: this.props.formatter && this.props.defaultValue ? this.props.formatter.format(this.props.defaultValue) : this.props.defaultValue, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, onKeyPress: this.onKeyPress, "aria-label": this.props.label, "data-automationid": this.props.automationId, maxLength: this.props.maxLength, required: this.props.required, pattern: this.props.pattern, disabled: this.props.disabled, error: this.props.error }),
            this.props.label && (this.state.value || this.state.focused) &&
                react_1.default.createElement(Label, { disabled: this.props.disabled }, this.props.label),
            this.props.error &&
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ErrorIcon, null, this.props.theme.svgs.error),
                    react_1.default.createElement(ErrorMessage, null, this.props.error))));
    };
    TextField.propTypes = {
        /** string to be shown alongside this field */
        label: prop_types_1.default.string,
        /** default string value */
        defaultValue: prop_types_1.default.string,
        /** if true, user will not be able to edit this field */
        disabled: prop_types_1.default.bool,
        /** hint for showing appropriate on screen keyboard and default input filtering */
        type: prop_types_1.default.oneOf(["text", "number", "email"]),
        /** maximum number of characters to allow in input */
        maxLength: prop_types_1.default.number,
        /** Specifies a regular expression that an <input> element's value is checked against */
        pattern: prop_types_1.default.string,
        /** Specifies that an input field must be filled out before submitting the form */
        required: prop_types_1.default.bool,
        formatter: prop_types_1.default.shape({ format: prop_types_1.default.func }),
        /** pass when content of field is invalid */
        error: prop_types_1.default.string,
        onChange: prop_types_1.default.func,
        onSubmit: prop_types_1.default.func,
        /** Id to reference the input by in functional testing */
        automationId: prop_types_1.default.string
    };
    TextField.defaultProps = {
        type: "text"
    };
    return TextField;
}(react_1.Component));
exports.default = styled_components_1.withTheme(TextField);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=TextField.js.map